import React from "react";
import { TextOqt, WrapperComponent } from "../..";

export const FormNodeBase = ({fmk}) => {
  return (
    <>
      <WrapperComponent caption="Titulo" Field={<TextOqt autoFocus name="label" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Contenido" Field={<TextOqt name="content" formik={fmk} variant="standard" multiline={true}/>}/>
    </>
  )
}
